/**
 * SGKC006A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface Sgkc006aReqTankatableSearchinfoDto {

    /**
     * 会社グループコード
     */
    companygroupcode?: string;
    /**
     * 会社コード
     */
    companycode?: string;
    /**
     * エネルギー種別コード
     */
    energyClscode?: string;
    /**
     * 承認権限コード
     */
    apprvAuthorityCode?: string;
    /**
     * ＬＰ販売形態コード
     */
    lpSalesformcode?: string;
    /**
     * 地点群供給地点区分番号
     */
    locationgroupSuppntDivisionnumber?: string;
    /**
     * 検索対象年月
     */
    searchTargetYm?: string;
    /**
     * 承認ステータスコード
     */
    apprvStatuscode?: string;
    /**
     * 早見表出力対象フラグ
     */
    referencetableOutputTargetflag?: boolean;
}

